module.exports = __webpack_public_path__ + "static/media/cfi-logo.81b6a489.webp";